import { logError } from '@/lib/sentry.lib';

import { useEffect } from 'react';

import { type QueryErrorProps, QueryError as QueryErrorView } from '@repo/ui/query-error';

export const QueryError = ({ error, textKey }: QueryErrorProps) => {
    useEffect(() => {
        logError(error);
    }, [error]);

    return <QueryErrorView error={error} textKey={textKey} />;
};
